import styled from "styled-components";

export const DeleteAccountContainer = styled.div`
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
`